import set from 'lodash/set';

const getFormComponentTree = component => {
  const tag = 'FormControl';
  const formGroupTag = 'FormGroup';

  let tree = {}
  for (let i = 0; i < component.$children.length; i++) {
    const child = component.$children[i];
    let groupName = ''

    if (child.$options._componentTag == formGroupTag) { // When coming across a FormGroup
      groupName += child.$options.propsData.name; // If so, append the groupName to the prefix
    }

    if (child.$options._componentTag == tag) { // When coming across a FormControl
      const controlName = child.$parent.$options.propsData.name;
      const prefix = groupName ? groupName + '.' : groupName;
      set(tree, prefix + controlName, child); // Append the Control as {groupName}.{controlName}
    } else if (child?.$children?.length) { // If not coming across a FormControl, check if the component has any children
      const childTree = getFormComponentTree(child); // Repeat this

      if (childTree) {
        const prefix = groupName ? (groupName + '.') : groupName

        for (const name in childTree) {
          if (childTree.hasOwnProperty(name)) {
            set(tree, prefix + name, childTree[name])
          }
        }
      }
    }
  }
  return tree;
}


export default getFormComponentTree;
